'use client'

import { usePathname } from 'next/navigation'
import { Eye, FileText } from 'lucide-react'
import { cn } from '@/lib/utils'
import { TracedLink } from '../components/TracedLink'
import { useAuth } from '@/providers/auth-provider'
import { getCompaniesWithPermission } from '@/utils/permissions'

const allNavItems = [
  { value: 'feed', label: 'הזנת החזקות', icon: FileText, path: '/holdings', requiresWrite: true },
  {
    value: 'view',
    label: 'צפייה בהחזקות',
    icon: Eye,
    path: '/holdings/view',
    requiresWrite: false,
  },
]

export function HoldingsNav() {
  const pathname = usePathname()
  const { user } = useAuth()

  const hasWritePermission = getCompaniesWithPermission(user, 'write').length > 0

  const navItems = allNavItems.filter((item) => !item.requiresWrite || hasWritePermission)

  return (
    <div className="flex justify-start pb-[15px] pr-8" dir="rtl">
      <nav className="grid grid-cols-2 gap-4">
        {navItems.map((item) => {
          const Icon = item.icon
          const isActive = pathname === item.path

          return (
            <TracedLink
              key={item.value}
              href={item.path}
              className={cn(
                'flex items-center text-sm font-medium transition-all duration-200 hover:text-primary px-2 py-1 rounded-md cursor-pointer',
                isActive
                  ? 'text-primary bg-primary/10 shadow-sm border border-primary/20'
                  : 'text-muted-foreground hover:bg-muted',
              )}
            >
              <Icon className="h-4 w-4 ml-2" />
              {item.label}
            </TracedLink>
          )
        })}
      </nav>
    </div>
  )
}
